// extracted by mini-css-extract-plugin
module.exports = {"container":"_61cc05a7c9--container--BYRL2"};